import { InfoIcon } from "assets/icons";
import { t } from "i18next";
import { InfoTooltipIcon } from "ui";

import { ProblemNotesForAdmin } from "../../../constants";
import { OrderProblemNotesTooltipProps } from "../OrdersTable.types";

import styles from "../OrdersTable.module.scss";

export const OrderProblemNotesTooltip = ({
  tooltipId,
  problemNotesForAdmin
}: OrderProblemNotesTooltipProps) => {
  const tooltipText = problemNotesForAdmin
    .map((note) => {
      if (
        note ===
        ProblemNotesForAdmin.ResellerReachedMaxConsecutiveNumberOfFailedOrders
      ) {
        return t(
          "User reached max consecutive number of failed orders. COD payment method will be disabled for this user"
        );
      }
      return note;
    })
    .join(`\n`);

  return problemNotesForAdmin.length > 0 ? (
    <InfoTooltipIcon
      id={tooltipId}
      iconClassName={styles.ordersTable_infoTooltipIcon}
      iconSize={18}
      IconComponent={InfoIcon}
      tooltipText={tooltipText}
    />
  ) : null;
};
